import { baseApi } from '@app/store/index.api';

import {
  ITraderWalletResponse,
  IChangeTraderWalletStatusQuery,
  IChangeTraderWalletStatusResponse,
  IVerifyTraderWalletResponse,
} from '../model/types';

const traderWalletApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getTraderWallets: builder.query<ITraderWalletResponse, string>({
      query: query => {
        return {
          url: `/pd/trader-wallets/deposit?${query}`,
        };
      },
    }),
    changeTraderWalletStatus: builder.mutation<
      IChangeTraderWalletStatusResponse,
      IChangeTraderWalletStatusQuery
    >({
      query: ({ id, status, reason }) => {
        return {
          url: `/trader-wallets/${id}/status`,
          method: 'PATCH',
          body: reason ? { status, reason } : { status },
        };
      },
    }),
    verifyTraderWallet: builder.mutation<IVerifyTraderWalletResponse, string>({
      query: id => {
        return {
          url: `/pd/trader-wallets/${id}/verify`,
          method: 'PATCH',
        };
      },
    }),
  }),
});

export const {
  useGetTraderWalletsQuery,
  useChangeTraderWalletStatusMutation,
  useVerifyTraderWalletMutation,
} = traderWalletApi;
